// src/server/logger.ts
import fs from 'fs';
import path from 'path';

// Directory and file where errors are logged
const LOG_DIR = path.join(process.cwd(), 'logs');
const LOG_FILE = path.join(LOG_DIR, 'error.log');

// Set max file size to 500MB
const MAX_LOG_SIZE = 500 * 1024 * 1024;
const MAX_BACKUPS = 5;

let isRotating = false;

// Ensure the logs directory exists
try {
  if (!fs.existsSync(LOG_DIR)) {
    fs.mkdirSync(LOG_DIR, { recursive: true });
  }
} catch (error) {
  console.error('Failed to create logs directory:', error);
}

function removeExtraBackups() {
  let backups;
  try {
    backups = fs
      .readdirSync(LOG_DIR)
      .filter((file) => file.startsWith('error-') && file.endsWith('.log'))
      .map((file) => ({
        name: file,
        path: path.join(LOG_DIR, file),
      }));
  } catch (err) {
    console.error('Error reading directory:', err);
    return;
  }

  while (backups.length > MAX_BACKUPS) {
    const backup = backups.shift();
    if (!backup) break;

    try {
      if (fs.existsSync(backup.path)) {
        fs.unlinkSync(backup.path);
      } else {
        console.warn(`Backup file not found: ${backup.path}`);
      }
    } catch (err) {
      console.error(`Failed to delete backup file ${backup.path}:`, err);
    }
  }
}

function checkLogSizeAndRotate() {
  if (isRotating) return;
  try {
    isRotating = true;
    const stats = fs.statSync(LOG_FILE);
    if (stats.size > MAX_LOG_SIZE) {
      const backupFile = path.join(LOG_DIR, `error-${Date.now()}.log`);
      fs.renameSync(LOG_FILE, backupFile);
      removeExtraBackups();
    }
  } catch (_) {
  } finally {
    isRotating = false;
  }
}

function logError({ url, errorMessage, duration }) {
  try {
    checkLogSizeAndRotate();
    const timestamp = new Date().toISOString();
    const logEntry = `[${timestamp}] [URL: ${url}] [Duration: ${duration}ms] [Error: ${errorMessage}]\n`;
    fs.appendFileSync(LOG_FILE, logEntry, 'utf8');
  } catch (err) {
    console.error('Failed to write to log file:', err);
  }
}

export const logger = {
  logError,
};
